import RechargeCreditCardView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useSelector } from "react-redux";
import { PAYMENT_TYPE } from "@/redux/ducks/customer";
import useCreditCardForm from "../hooks/useCreditCardForm";

export default function RechargeCreditCard() {

  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    error,
    errorChangeMethod,
    errors,
  } = useCreditCardForm({navigate});

  const goBack = () => {
    if (customer?.account?.paymentType === PAYMENT_TYPE.IS_CARD) {
      navigate('/payment/card');
      return;
    }
    navigate('/payment');
  }

  const goToFinished = () => navigate("/payment/finished");

  return (
    <RechargeCreditCardView
      isLoading={isLoading}
      goBack={goBack}
      isDisabled={isDisabled}
      error={error}
      errorChangePaymentMethod={errorChangeMethod}
      goToFinished={goToFinished}
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
    />
  );
}
